import { Color, DefaultValue, getDefaultTransition, Icon, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { Input } from '../Form'

export const IconMagnifier = styled(Icon)`
  position: absolute;
  top: ${Spacing.S12};
  left: ${Spacing.S12};
  cursor: pointer;
`

export const IconX = styled(Icon)`
  position: absolute;
  top: ${Spacing.S12};
  right: ${Spacing.S12};
  left: auto;
  cursor: pointer;
`

interface SearchInputProps {
  isActive?: boolean
}

export const SearchInput = styled(Input)<SearchInputProps>`
  margin-bottom: 0;

  input {
    opacity: 0;
    width: 0;
    height: 40px;
    padding: ${Spacing.S12};
    padding-left: ${Spacing.S40};
    border: 1px solid ${Color.Grey200};
    border: 1px solid ${Color.Grey200};
    border-radius: ${DefaultValue.BorderRadius};
    background-color: ${Color.White};
    pointer-events: none;
    ${getDefaultTransition('width', 'opacity')}

    ${({ isActive }) => {
      if (isActive) {
        return `
        pointer-events: all;
        width: 304px;
        opacity: 1;
      `
      }
    }}
  }
`

export const LoupeInputWrapper = styled.div`
  position: relative;
`
